'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('frontpage-slider-editor', {
      url: '/admin/frontpage-slider-editor',
      template: '<frontpage-slider-editor></frontpage-slider-editor>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/frontpage-slider/frontpage-slider-editor.routes.js